import { render } from "./EmploymentStatus.vue?vue&type=template&id=6f9d8cbd"
import script from "./EmploymentStatus.vue?vue&type=script&lang=js"
export * from "./EmploymentStatus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__